import { useEffect, useMemo, useState } from 'react';
import authHeader from "services/auth/jwt/auth-header";
import customAxios from "../util/Api";

export const useReports = () => {
    const [allReports, setAllReports] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        fetchReports();
    }, []);

    const fetchReports = async () => {
        setLoading(true);
        try {
            const response = await customAxios.get('PbiEmbed/GetAllReports', { headers: authHeader() });
            if (response.status === 200) {
                const list = Array.isArray(response?.data?.value)
                    ? response.data.value
                    : Array.isArray(response?.data)
                        ? response.data
                        : [];
                setAllReports(list);
            }
        } catch (err) {
            console.log(err);
            setAllReports([]);
        } finally {
            setLoading(false);
        }
    };

    // Pass varID (GUID) to fetch the embed token/config for a given report.
    const getEmbedToken = async (varID) => {
        try {
            const response = await customAxios.get(`PbiEmbed/GenerateEmbedToken/${varID}`, {
                headers: authHeader(),
            });
            if (response.status === 200) {
                return response.data;
            }
            return null;
        } catch (err) {
            console.log(err);
            throw err;
        }
    };

    // Flat list filtered by subMenuName (the display name for each report).
    const filteredFlatReports = useMemo(() => {
        const source = Array.isArray(allReports) ? allReports : [];
        if (!searchText.trim()) return source;
        const q = searchText.toLowerCase();
        return source.filter((item) => item.subMenuName?.toLowerCase().includes(q));
    }, [searchText, allReports]);

    // Grouped by groupName -> array of { groupName, subMenuName, varID, reportID }
    const groupedReports = useMemo(() => {
        const groups = {};
        filteredFlatReports.forEach((item) => {
            const key = item.groupName || 'Other';
            if (!groups[key]) groups[key] = [];
            groups[key].push(item);
        });
        return groups;
    }, [filteredFlatReports]);

    const clearSearch = () => setSearchText('');

    return {
        allReports,
        filteredFlatReports,
        groupedReports,
        loading,
        searchText,
        setSearchText,
        clearSearch,
        refetch: fetchReports,
        getEmbedToken,
    };
};